import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SemaforoSection } from './components/SemaforoSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { IdentitySection } from './components/IdentitySection';
import { NotSection } from './components/NotSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SemaforoSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <IdentitySection data-id="element-5" />
      <NotSection data-id="element-6" />
      <ClosingSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}